<div style="position: relative;">
	<app-loader [showLoader]="showLoad"></app-loader>
	<div
		class="c-portlet o-block u-width-100p _u-width-100p u-shadow-mini u-bg-primary {{ sectionclass }}"
		style="position: relative;"
	>
		<div
			class="c-portlet__header o-stack o-stack--center o-stack--splitted u-border-bottom u-px-small u-py-mini c-portlet-gap u-border-bottom"
			style="position: relative;"
			*ngIf="campaignCarouselItem"
		>
			<div class="o-stack__cell">
				<h5>Lift Trend: {{ campaignCarouselItem.name }}</h5>
			</div>
			<!-- carousel icons start -->
			<div class="carousel-width_p2">
				<div class="o-stack o-stack&#45;&#45;center o-stack&#45;&#45;nowrap o-stack&#45;&#45;tinyGap u-font-small">
					<div class="u-relative" id="navigation-button" *ngIf="campaignsList.length > 1">
						<a href="javascript:void(null)" class="previous-arrow-button">
							<img (click)="prevArrow()" src="../../../../../assets/images/arrow-right.svg" />
						</a>
						<a href="javascript:void(null)" class="next-arrow-button">
							<img (click)="nextArrow()" src="../../../../../assets/images/arrow-right.svg" />
						</a>
					</div>
				</div>
			</div>
			<!-- carousel icons end -->
		</div>
		<h3 *ngIf="campaignCarouselItem" class="primary-color" id="campaign-name">{{ campaignCarouselItem.name }}</h3>
		<div *ngIf="!campaignCarouselItem" class="no-data-header-lift-trend">
			<div
				class="c-portlet__header o-stack o-stack--center o-stack--splitted u-border-bottom u-px-small u-py-mini c-portlet-gap u-border-bottom lift-trend-no-data-header"
				style="position: relative; font-size: 1.1em;"
			>
				Lift Trends
			</div>
		</div>
		<div>
			<div class="c-portlet__content u-pt-small" style="width: 100%;" *ngIf="campaignCarouselItem">
				<div class="o-stack o-stack--center o-stact_ImgSpecs" style="height: auto;">
					<div class="charts-container product-lift-chart-container" style="margin: 0 auto;">
						<div class="chart-layout">
							<div [id]="'campaign' + i" class="individual-chart">
								<app-chart class="individual-chart" [chartData]="campaignCarouselItem"></app-chart>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div
				class="c-portlet__content u-pt-small lift-trend-no-data-body"
				style="position: absolute; top: 0px; left: 0px; width: 100%; height: 100%;"
				*ngIf="!campaignCarouselItem"
			>
				<img [src]="placeholderimage" class="lift-trend-no-data-placeholder" style="width: 80%;" />
			</div>
		</div>
	</div>
	<div class="no-data-container" *ngIf="!hasData">
		<div
			class="c-portlet o-block u-width-100p _u-width-100p u-shadow-mini u-bg-primary {{ sectionclass }}"
			style="position: relative;"
		>
			<div
				class="c-portlet__header o-stack o-stack--center o-stack--splitted u-border-bottom u-px-small u-py-mini c-portlet-gap u-border-bottom"
				style="position: relative;"
			>
				<div class="o-stack__cell">
					<h5>Lift Trend</h5>
				</div>
			</div>
		</div>
		<div class="map-no-data">No Data to Display</div>
	</div>
</div>
